.banner {
    background: repeating-linear-gradient(
        -45deg,
        var(--mantine-color-red-8) 0 14px,
        var(--mantine-color-red-9) 14px 28px
    );
    color: var(--mantine-color-white);
    font-size: var(--mantine-font-size-sm);
    font-weight: 700;
    line-height: 30px;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
}
